// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { klaytn as _klaytn } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the klaytn chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8217
 * Chain Name: Klaytn
 * Default Block Explorer: https://scope.klaytn.com
 * Default RPC URL: https://public-en-cypress.klaytn.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { klaytn } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: klaytn,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const klaytn = createCommon({
	..._klaytn,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
